function initGalleryNav() {
  const mainSlider = document.querySelector('.product .slider-mobile-gutter');
  if (!mainSlider || mainSlider.querySelector('.lyon-gallery-nav')) return;

  const thumbs = document.querySelectorAll('.thumbnail-list .thumbnail');
  if (thumbs.length < 2) return;

  mainSlider.style.position = 'relative';

  const prev = document.createElement('button');
  prev.type = 'button';
  prev.className = 'lyon-gallery-nav lyon-gallery-nav--prev';
  prev.setAttribute('aria-label', 'Previous image');
  prev.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M15 18l-6-6 6-6"/></svg>';

  const next = document.createElement('button');
  next.type = 'button';
  next.className = 'lyon-gallery-nav lyon-gallery-nav--next';
  next.setAttribute('aria-label', 'Next image');
  next.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M9 18l6-6-6-6"/></svg>';

  mainSlider.appendChild(prev);
  mainSlider.appendChild(next);

  function getActiveIndex() {
    const active = document.querySelector('.thumbnail-list .thumbnail[aria-current="true"], .thumbnail-list .thumbnail.is-active');
    if (!active) return 0;
    return [...thumbs].indexOf(active);
  }

  function clickThumb(index) {
    if (index < 0) index = thumbs.length - 1;
    if (index >= thumbs.length) index = 0;
    const thumb = thumbs[index];
    const btn = thumb.querySelector('button') || thumb;
    btn.click();
  }

  prev.addEventListener('click', e => {
    e.stopPropagation();
    e.preventDefault();
    clickThumb(getActiveIndex() - 1);
  });

  next.addEventListener('click', e => {
    e.stopPropagation();
    e.preventDefault();
    clickThumb(getActiveIndex() + 1);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGalleryNav);
} else {
  initGalleryNav();
}
